const PAGINATION_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

const PAGINATION_KEYS = {
  limit: 'limit',
  offset: 'offset',
  order: 'order',
  orderBy: 'orderBy',
  count: 'count'
} as const;

const DEFAULT_TABLE_LIMIT = 20;
const MAX_TABLE_LIMIT = 100;

const INIT_PAGINATION = {
  limit: MAX_TABLE_LIMIT,
  offset: 0,
  order: PAGINATION_ORDER.DESC,
  count: 0
} as const;

export { PAGINATION_ORDER, PAGINATION_KEYS, INIT_PAGINATION, DEFAULT_TABLE_LIMIT, MAX_TABLE_LIMIT };
